import { getFlatDataFromTree } from 'react-sortable-tree'

const cleanText = text => {
	if (text) return text.trim()

	return false
}

// Build tree from API data
// Loop-through parents and look for children
const traverseParent = (parent, children, t) => {
	let obj = parent

	// Look for children item in children[]
	if (children[obj.id]) {
		children[obj.id].map(child => {
			const id = `a${obj.id}`
			const expanded =
				localStorage.getItem(id) && localStorage.getItem(id) === 'true'

			if (obj.children && obj.children.length) {
				obj = {
					...obj,
					title: cleanText(obj.title) || t('no_title'),
					expanded,
					isDirectory: true,
					children: [
						...obj.children,
						traverseParent(child, children, t),
					],
				}
			} else {
				obj = {
					...obj,
					title: cleanText(obj.title) || t('no_title'),
					expanded,
					isDirectory: true,
					children: [traverseParent(child, children, t)],
				}
			}

			return true
		})
	} else {
		obj = {
			...obj,
			title: cleanText(obj.title) || t('no_title'),
		}
	}

	return obj
}

// Build tree from API data
// Root level
const makeTree = (articles, t) => {
	const children = []

	if (!articles) return null

	// 1. Sort by creation date
	// 2. Sort articles by 'order'
	// 3. Filter root level, separate children
	// 4. Merge root and child level
	// let treeData = []
	let articlesSorted = articles
		.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
		.sort((a, b) => a.order - b.order)
		.filter(article => {
			const title = article.title || t('no_title')
			const obj = {
				id: article.id,
				draft: article.draft,
				lockedBy: article.lockedBy,
				title,
				isDirectory: false,
			}

			if (article.parent) {
				if (!children[article.parent]) {
					children[article.parent] = []
				}

				children[article.parent].push(obj)

				return false
			}

			return obj
		})
		.map(parent => traverseParent(parent, children, t))
		.toArray()

	// Find lost articles
	const lostArticles = []

	Object.keys(children).forEach(id => {
		if (articles.filter(article => id === article.id).size === 0) {
			articlesSorted = [...articlesSorted, ...children[id]]
			children[id].forEach(child => {
				lostArticles[child.id] = true
			})

			console.warn('Lost articles found!')
		}
	})

	// Find children of lost articles
	Object.keys(lostArticles).forEach(id => {
		if (articles.filter(article => id === article.parent).size === 1) {
			articlesSorted = [...articlesSorted, ...children[id]]
		}
	})

	// articles.count() && console.log('Articles in props: ' + articles.count())
	// getFlatDataFromTree({treeData: articlesSorted, getNodeKey: function(){}}).length &&
	// 		console.log('Articles displayed: ' + getFlatDataFromTree({treeData: articlesSorted,
	//			getNodeKey: function(){}, ignoreCollapsed: false}).length)
	// console.log('-')
	if (
		articles.count() -
		getFlatDataFromTree({
			treeData: articlesSorted,
			getNodeKey: () => {},
			ignoreCollapsed: false,
		}).length
	) {
		console.warn(
			`Hidden articles: ${articles.count() -
				getFlatDataFromTree({
					treeData: articlesSorted,
					getNodeKey: () => {},
					ignoreCollapsed: false,
				}).length}`
		)
	}

	return articlesSorted
}

export { makeTree }
